import { FC, useState } from "react";
import { AuthBrandLogo } from "components/AuthBrandLogo";
import { Link } from "react-router-dom";
import { useForgotPassword } from "hooks/useAuth";
import styled from "@emotion/styled";
import { Button, Col, Form, Input, message, Row, Typography } from "antd";

const ForgotPasswordPage: FC = () => {
  const [submitted, setSubmitted] = useState(false);
  const [form] = Form.useForm();

  const { mutate: requestForgotPassword, isPending } = useForgotPassword();

  const handleSubmit = (values: { email: string }) => {
    requestForgotPassword(
      { email: values.email, app_name: "factory" },
      {
        onSuccess: (data) => {
          if (data.status === "success") {
            setSubmitted(true);
            message.success("ส่ง email เรียบร้อย กรุณาตรวจสอบ inbox ของท่าน");
          } else {
            message.error(data.error_message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
          }
        },
        onError: () => {
          message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        },
      }
    );
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#fff" }}>
      <Row gutter={[0, 0]}>
        <Col style={{ padding: 0 }} xs={{ span: 0 }} lg={{ span: 16 }} md={{ span: 16 }}>
          <BackgroundGradient>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
              <AuthBrandLogo />
            </div>
          </BackgroundGradient>
        </Col>
        <Col
          xs={{ span: 24, offset: 0 }}
          lg={{ span: 8, offset: 0 }}
          md={{ span: 8 }}
          style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100vh" }}
        >
          <SectionText>
            <Typography.Title level={4}>ลืมรหัสผ่าน</Typography.Title>
          </SectionText>
          <SectionText>
            <Typography.Text type="secondary">
              กรอก email ที่ลงทะเบียนไว้ ระบบจะส่งลิงก์รีเซ็ตรหัสผ่านให้ท่าน
            </Typography.Text>
          </SectionText>

          <SectionInput style={{ marginTop: 20 }}>
            {submitted ? (
              <div style={{ textAlign: "center" }}>
                <Typography.Text>
                  ส่ง email เรียบร้อยแล้ว กรุณาตรวจสอบ inbox และ spam folder ของท่าน
                </Typography.Text>
              </div>
            ) : (
              <Form onFinish={handleSubmit} layout="vertical" form={form} style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: "กรุณากรอก email" },
                    { pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: "กรุณากรอก email ที่ถูกต้อง" },
                  ]}
                >
                  <Input placeholder="Email" autoComplete="off" size="large" />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" style={{ width: "100%" }} loading={isPending} size="large">
                    ส่งลิงก์รีเซ็ตรหัสผ่าน
                  </Button>
                </Form.Item>
              </Form>
            )}

            <div style={{ textAlign: "center", marginTop: 16 }}>
              <Link to="/sign-in">กลับหน้าเข้าสู่ระบบ</Link>
            </div>
          </SectionInput>
        </Col>
      </Row>
    </div>
  );
};

export default ForgotPasswordPage;

const SectionText = styled.div`
  width: 100%;
  margin-top: 10px;
  text-align: center;
  padding: 0 5px;
`;

const SectionInput = styled.div`
  padding: 0 20px;
`;

const BackgroundGradient = styled.div`
  background: linear-gradient(45deg, #2777c8, #fff);
  width: 100%;
  height: 100vh;
`;
